import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getLabelForId } from '../../utils';
import LivestreamLatestVideosUI from './LivestreamLatestVideosUI';

const LivestreamLatestVideos = ({ videos, videoCategories = [] }) => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const selectedFilterLabel = getLabelForId(videoCategories, selectedFilter);

  const [searchText, setSearchText] = useState('');

  const filteredVideos = videos
    .filter(
      video =>
        selectedFilter === 'all' ||
        video.categories.includes(selectedFilterLabel)
    )
    .filter(video =>
      searchText
        ? video.title.toLowerCase().includes(searchText.toLowerCase()) ||
          video.category.toLowerCase().includes(searchText.toLowerCase())
        : true
    );

  return (
    <LivestreamLatestVideosUI
      searchText={searchText}
      setSearchText={setSearchText}
      selectedFilter={selectedFilter}
      setSelectedFilter={setSelectedFilter}
      videoCategories={videoCategories}
      videos={filteredVideos}
    />
  );
};

LivestreamLatestVideos.propTypes = {
  videoCategories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
    })
  ),
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      category: PropTypes.string,
      image: PropTypes.string,
      isRecordedLive: PropTypes.bool,
      title: PropTypes.string,
      videoId: PropTypes.string,
      videoLength: PropTypes.string,
    })
  ),
};

export default LivestreamLatestVideos;
